import { render, staticRenderFns } from "./WizardInfo.vue?vue&type=template&id=c0c03c4e&"
import script from "./WizardInfo.vue?vue&type=script&lang=js&"
export * from "./WizardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports